<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "2rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path d="M19.5 10a1 1 0 001 1h6a1 1 0 001-1V4a1 1 0 00-2 0v3.15a13 13 0 101.75 15.35 1 1 0 00-.37-1.37 1 1 0 00-1.36.37A11 11 0 1124.45 9H20.5a1 1 0 00-1 1z"/></svg>